<div class="bg-grey-100 md:bg-accent">
    <div class="block px-24 py-8 md:hidden">
        <div class="bg-grey-300 h-1 w-full"></div>
    </div>
    <div class="inner-page-wrapper flex flex-col items-center justify-between gap-24 pt-16 pb-24 md:flex-row md:pt-24">
        <div class="xs:gap-32 flex flex-wrap gap-16">
            @if (data(); as d) {
                @for (item of d; track $index; let last = $last) {
                    <div>
                        @let label = item.label | footnotes;
                        <span class="text-16 text-accent leading-27 md:text-white" [innerHTML]="label()"></span>
                        <div class="text-accent mt-2 flex items-end gap-4 md:text-white">
                            <span class="font-headline text-31 md:text-50 leading-36 font-medium md:leading-58">
                                {{ item.value }}
                            </span>
                            <span class="font-headline text-14 md:text-20 mb-5 leading-12 font-medium md:leading-30">
                                {{ item.unit }}
                            </span>
                        </div>
                        @if (item.link && item.linkText) {
                            <a
                                ui-m010-c020-icon-link
                                class="mt-4 hidden md:inline-flex"
                                [hyundaiRouterLink]="item.link"
                                inverted
                            >
                                {{ item.linkText }}
                            </a>
                            <a
                                ui-m010-c020-icon-link
                                class="mt-4 inline-block md:hidden"
                                [hyundaiRouterLink]="item.link"
                            >
                                {{ item.linkText }}
                            </a>
                        }
                    </div>
                    @if (!last) {
                        <div class="bg-grey-300 my-8 h-auto w-1 md:bg-white"></div>
                    }
                }
            }
        </div>

        <div class="flex w-full flex-col gap-16 md:w-auto">
            <a
                class="button-primary md:text-accent md:w-auto md:bg-white md:hover:bg-white"
                [hyundaiRouterLink]="primaryButton()"
                [trackingElTarget]="primaryButton()"
                tracking
                trackingElType="button"
                trackingElEvent="engagement_click"
                trackingElLabel="Test Drive"
            >
                {{ primaryButtonText() }}
            </a>
        </div>
    </div>
</div>
